export default function initBackgroundVideo() {
    window.addEventListener('load', function (event) {
        document.querySelectorAll('.card-background-video-desktop').forEach($videoDesktop => {
            console.log($videoDesktop);
            if ($videoDesktop && window.innerWidth >= 1024) {
                $videoDesktop.setAttribute('autoplay', '');
                $videoDesktop.play();
            }
        });
        document.querySelectorAll('.card-background-video-mobile').forEach($videoTablet => {
            if ($videoTablet && window.innerWidth >= 769 && window.innerWidth < 1024) {
                $videoTablet.setAttribute('autoplay', '');
                $videoTablet.play();
            }
        });
        document.querySelectorAll('.card-background-video-tablet').forEach($videoMobile => {
            if ($videoMobile && window.innerWidth < 769) {
                $videoMobile.setAttribute('autoplay', '');
                $videoMobile.play();
            }
        });
    });
}
